/**
 * Identifiers for top-level application sections.
 *
 * Used as the value of `activeSectionId` in AppContext.
 * - On mobile: identifies the current section for URL sync and navigation
 *   handoffs; AppRuntime does not currently enforce single-view mounting.
 * - On desktop: sections with depth > 0 are conditionally mounted/unmounted
 *   based on `activeSectionId` (sections are shown when active section depth
 *   is >= their depth).
 *
 * Depth ordering: hero/catalog (0) → tiers (1) → product (2).
 * Example: `activeSectionId === SECTION_ID.PRODUCT` shows hero, tiers and product.
 */
export const SECTION_ID = {
  HERO:    'hero',
  CATALOG: 'catalog',
  TIERS:   'tiers',
  PRODUCT: 'product',
  FAVORITES: 'favorites',
}

/**
 * Depth of each section — used to determine which sections are visible
 * when a given section is active.
 *
 * @type {Record<string, number>}
 */
export const SECTION_DEPTH = {
  [SECTION_ID.HERO]:    0,
  [SECTION_ID.CATALOG]: 0,
  [SECTION_ID.TIERS]:   1,
  [SECTION_ID.PRODUCT]: 2,
  [SECTION_ID.FAVORITES]: 0,
}
